import React from 'react';
import Select from 'components/common/Select';
import Program from 'utils/program';
import { ProgramDTO } from '@peartherapeutics/weaver-api-client';

interface IOwnProps {
  programs: ProgramDTO[];
  onChange: () => void;
  setProgram?: (program: ProgramDTO) => void;
}

type SelectProgramType = IOwnProps;

const SelectProgram = (props: SelectProgramType) => {
  const { onChange, setProgram, programs } = props;

  const handleOnChangeProgram = (option: IOptionType) => {
    const value = String(option.value);
    const program = programs.find(
      (program) => program.name.toLowerCase() === value,
    );
    Program.set(program);
    onChange();
    if (setProgram && program) setProgram(program);
  };

  const options: IOptionType[] = programs
    .map((program) => ({
      value: program.name.toLowerCase(),
      label: program.label,
    }))
    .filter(
      (option, index) =>
        programs.findIndex((opt) => opt.label === option.label) === index,
    );

  return (
    <Select
      placeholder="Select Product"
      emptyDataHelper="No Product Available"
      options={options}
      onChange={handleOnChangeProgram}
    />
  );
};

export default SelectProgram;
